import { motion } from "framer-motion";

const defaultVariants = {
  hidden: { opacity: 0, y: 36 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
  },
};

export const Reveal = ({
  children,
  className = "",
  delay = 0,
  variants = defaultVariants,
  as = "div",
}) => {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={variants}
      transition={{ delay }}
    >
      {children}
    </Comp>
  );
};

export const RevealGroup = ({ children, className = "", stagger = 0.12 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.15 }}
    transition={{ staggerChildren: stagger }}
  >
    {children}
  </motion.div>
);

export const RevealItem = ({ children, className = "" }) => (
  <motion.div className={className} variants={defaultVariants}>
    {children}
  </motion.div>
);
